import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { coachOnboardApi } from "../../api/coachOnboardApi";

export const onboardCoach = createAsyncThunk(
  "coachOnboard/onboardCoach",
  async ({ id, offerId }, { rejectWithValue }) => {
    try {
      const response = await coachOnboardApi({ id, offerId });
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const coachOnboardSlice = createSlice({
  name: "coachOnboard",
  initialState: {
    loading: false,
    success: null,
    error: null,
  },
  reducers: {
    clearCoachOnboardState: (state) => {
      state.loading = false;
      state.success = null;
      state.error = null;
    },
    clearCoachOnboardError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(onboardCoach.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onboardCoach.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
        state.error = null;
      })
      .addCase(onboardCoach.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCoachOnboardState, clearCoachOnboardError } =
  coachOnboardSlice.actions;
export default coachOnboardSlice.reducer;
